import { render, staticRenderFns } from "./ForumView.vue?vue&type=template&id=7cbfd690&scoped=true&"
import script from "./ForumView.vue?vue&type=script&lang=js&"
export * from "./ForumView.vue?vue&type=script&lang=js&"
import style0 from "./ForumView.vue?vue&type=style&index=0&id=7cbfd690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbfd690",
  null
  
)

export default component.exports